/* eslint-disable  */
import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Model, { TestModel } from '@tripian/model';
import { api } from '@tripian/core';
import { changeLoadingPlans, changeLoadingReference, changePlans, changeReference, saveError } from '../redux/action/trip';
import ICombinedState from '../redux/model/ICombinedState';
import { City } from '@tripian/model/api/v3';

const useTripTest = () => {
  const [loadingTripAdd, setLoadingTripAdd] = useState<boolean>(false);

  const { loadingTripReference, tripReference } = useSelector((state: ICombinedState) => ({
    loadingTripReference: state.trip.loading.reference,
    tripReference: state.trip.reference,
  }));
  const dispatch = useDispatch();

  const tripAddTest = useCallback(
    (tripProfile: TestModel.ITestTripProfile, minDayIndex = 0): Promise<TestModel.ITestTripReponse> => {
      setLoadingTripAdd(true);

      return api
        .tripAddTest(tripProfile, minDayIndex)
        .then((trip: TestModel.ITestTripReponse) => {
          return trip;
        })

        .catch((tripAddError) => {
          dispatch(saveError('tripAdd', 'Add Trip', tripAddError));
          throw tripAddError;
        })
        .finally(() => {
          setLoadingTripAdd(false);
        });
    },
    [dispatch],
  );

  const tripFetchCallback = useCallback(
    (tripData: Model.Trip) => {
      dispatch(
        changeReference({
          id: tripData.id,
          trip_hash: tripData.trip_hash,
          city: tripData.city,
          trip_profile: tripData.trip_profile,
        }),
      );
      dispatch(changePlans(tripData.plans));
    },
    [dispatch],
  );

  const tripFetchTest = useCallback(
    (hash: string, minDayIndex = 0, force = false): Promise<TestModel.ITestTripReponse> => {
      dispatch(changeLoadingReference(true));
      dispatch(changeLoadingPlans(true));

      return api
        .tripTest(hash, minDayIndex, force)
        .then((testTrip: TestModel.ITestTripReponse) => {
          const toronto: City = {
            id: 144,
            name: 'Toronto',
            image: { url: 'https://poi-pics.s3-eu-west-1.amazonaws.com/City/144/featured.jpg', image_owner: { title: null, url: null, avatar: null }, width: 1080, height: 608 },
            boundary: [43.48499, 43.89912, -79.56781, -79.14481],
            coordinate: { lat: 43.653226, lng: -79.38318429999998 },
            country: { name: 'Canada', code: 'ca', continent: { name: 'North America' } },
            tastes: [],
            description:
              'Toronto is the provincial capital of Ontario. With a recorded population of 2,731,571 in 2016, it is the most populous city in Canada and the fourth most populous city in North America. The city is the anchor of the Golden Horseshoe, an urban agglomeration of 9,245,438 people (as of 2016) surrounding the western end of Lake Ontario, while the Greater Toronto Area (GTA) proper had a 2016 population of 6,417,516. Toronto is an international center of business, finance, arts, and culture, and is recognized as one of the most multicultural and cosmopolitan cities in the world.',
            status: true,
          };
          const trip: Model.Trip = {
            id: testTrip.id,
            city: toronto,
            plans: testTrip.plans,
            trip_hash: testTrip.trip_hash,
            trip_profile: {
              accommodation: testTrip.trip_profile.days[0].params.accommodation,
              answers: testTrip.trip_profile.days[0].params.answers,
              arrival_datetime: '',
              city_id: toronto.id, // testTrip.trip_profile.days[0].params.city_id,
              companion_ids: testTrip.trip_profile.days[0].params.companion_ids,
              departure_datetime: '',
              do_not_generate: 0,
              number_of_adults: testTrip.trip_profile.days[0].params.adult_no,
              number_of_children: testTrip.trip_profile.days[0].params.child_no,
              owner: '',
              pace: 'FAST',
            },
          };

          tripFetchCallback(trip);
          return testTrip;
        })

        .catch((tripFetchError) => {
          dispatch(saveError('tripFetch', 'Get Trip', tripFetchError));
          throw tripFetchError;
        })
        .finally(() => {
          dispatch(changeLoadingReference(false));
          dispatch(changeLoadingPlans(false));
        });
    },
    [dispatch],
  );

  // const tripFetchWithRelational = async (hash: string, minDayIndex: number = 0, force = false): Promise<Model.Trip> => {
  //   const trip = await tripFetch(hash, minDayIndex, force);
  //   dispatch(fetchAlternatives(minDayIndex));
  //   dispatch(fetchReactions());
  //   dispatch(fetchFavorites());
  //   dispatch(
  //     fetchReservations(
  //       trip.city.id,
  //       moment()
  //         .subtract(1, 'days')
  //         .format('YYYY-MM-DD'),
  //     ),
  //   );
  //   return trip;
  // };

  /* const tripReferenceFetch = useCallback(
    (hash: string): Promise<Model.TripReference> =>
      api
        .tripRef(hash)
        // .then((tripReferenceData: Model.TripReference) => {
        //   return tripReferenceData;
        // })

        .catch((tripReferenceFetchError) => {
          dispatch(saveError('tripReferenceFetch', 'Get Trip', tripReferenceFetchError));
          throw tripReferenceFetchError;
        })
        .finally(() => {}),
    [dispatch],
  ); */

  /* const tripClear = useCallback(() => {
    dispatch(clear());
  }, [dispatch]); */

  return {
    loadingTripReference,
    loadingTripAdd,
    tripReference,
    tripAddTest,
    tripFetchTest,
  };
};

export default useTripTest;
